import config from '@/config'
import { Route } from '@/contracts/core/api/entity/Route'

/** Маршруты модуля education (/api/education): работать ли без сервера, решает настройка модуля в src/config.ts */
export abstract class EducationRoute<P, T> extends Route<P, T> {
  isOffline(): boolean {
    return config.modules.education.isOffline()
  }
}
